import React, { useState, useEffect } from 'react';
import FifaCard from './FifaCard';
import '../css/UserProfile.css';

const API_URL = process.env.REACT_APP_API_URL;

const allowedPositions = [
  'Kaleci',
  'Stoper',
  'Bek',
  'Orta Saha',
  'Ofansif Orta Saha',
  'Kanat',
  'Forvet',
];

const UserProfile = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    teams: '',
    position: '',
    speed: 60,
    shooting: 60,
    passing: 60,
    dribbling: 60,
    defense: 60,
    physical: 60,
  });

  // Şifre güncelleme state
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${API_URL}/api/profile/user`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (!response.ok) {
          alert('Profil bilgileri alınamadı.');
          return;
        }
        const data = await response.json();
        setFormData({
          ...data,
          ...(data.fifaStats || {})
        });
      } catch (error) {
        console.error('Profil alınamadı:', error);
      }
    };

    fetchProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/profile/user/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          ...formData,
          fifaStats: {
            speed: formData.speed,
            shooting: formData.shooting,
            passing: formData.passing,
            dribbling: formData.dribbling,
            defense: formData.defense,
            physical: formData.physical,
          }
        }),
      });

      if (!response.ok) {
        alert('Profil güncellenemedi.');
        return;
      }
      alert('Profil başarıyla güncellendi!');
    } catch (error) {
      console.error('Profil güncellenemedi:', error);
    }
  };

  // 🔒 ŞİFRE GÜNCELLEME
  const handlePasswordUpdate = async () => {
    if (!passwordData.oldPassword || !passwordData.newPassword) {
      return alert("Lütfen eski ve yeni şifrenizi girin.");
    }

    try {
      const response = await fetch(`${API_URL}/api/users/profile/change-password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(passwordData),
      });

      const data = await response.json();

      if (!response.ok) {
        return alert(data.message || 'Şifre güncellenemedi.');
      }

      alert("Şifreniz başarıyla güncellendi.");
      setPasswordData({ oldPassword: '', newPassword: '' });

    } catch (error) {
      console.error("Şifre güncelleme hatası:", error);
      alert("Bir hata oluştu.");
    }
  };

  // ❌ HESAP SİLME
  const handleDeleteAccount = async () => {
    const confirmDelete = window.confirm(
      "Hesabınızı kalıcı olarak silmek istediğinizden emin misiniz?\nBu işlem geri alınamaz!"
    );

    if (!confirmDelete) return;

    try {
      const response = await fetch(`${API_URL}/api/users/profile/delete`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        return alert("Hesap silinemedi.");
      }

      alert("Hesabınız başarıyla silindi. Hoşçakalın!");
      localStorage.clear();
      window.location.href = "/";

    } catch (error) {
      console.error("Hesap silinemedi:", error);
    }
  };

  return (
    <div className="container my-4">
      <h2 className="text-center mb-4">Profilimi Güncelle</h2>

      <div className="d-flex justify-content-center mb-4">
        <FifaCard user={{ ...formData, imageUrl: `${API_URL}/${formData.photo}` }} />
      </div>

      {/* PROFİL FORMU */}
      <form className="row g-3 mx-auto" onSubmit={handleSubmit} style={{ maxWidth: '600px' }}>
        <div className="col-12">
          <input
            type="text"
            className="form-control"
            placeholder="Ad Soyad"
            value={formData.fullName}
            onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
            required
          />
        </div>
        <div className="col-12">
          <input
            type="email"
            className="form-control"
            placeholder="E-posta"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
          />
        </div>
        <div className="col-12">
          <input
            type="text"
            className="form-control"
            placeholder="Telefon"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
        </div>
        <div className="col-12">
          <textarea
            className="form-control"
            rows="3"
            placeholder="Oynadığınız Takımlar"
            value={formData.teams}
            onChange={(e) => setFormData({ ...formData, teams: e.target.value })}
          />
        </div>
        <div className="col-12">
          <select
            className="form-select"
            value={formData.position}
            onChange={(e) => setFormData({ ...formData, position: e.target.value })}
            required
          >
            <option value="">Pozisyon Seçin</option>
            {allowedPositions.map((pos) => (
              <option key={pos} value={pos}>{pos}</option>
            ))}
          </select>
        </div>

        <div className="col-12 text-center">
          <button type="submit" className="btn btn-success rounded-pill px-4">Güncelle</button>
        </div>
      </form>

      {/* 🔒 ŞİFRE GÜNCELLEME */}
      <div className="container mt-5" style={{ maxWidth: "600px" }}>
        <h4>Şifre Güncelle</h4>
        <input
          type="password"
          className="form-control my-2"
          placeholder="Eski Şifre"
          value={passwordData.oldPassword}
          onChange={(e) => setPasswordData({ ...passwordData, oldPassword: e.target.value })}
        />
        <input
          type="password"
          className="form-control my-2"
          placeholder="Yeni Şifre"
          value={passwordData.newPassword}
          onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
        />
        <button className="btn btn-warning w-100" onClick={handlePasswordUpdate}>
          Şifreyi Güncelle
        </button>
      </div>

      {/* ❌ HESAP SİLME */}
      <div className="container mt-4" style={{ maxWidth: "600px" }}>
        <h4>Hesabımı Sil</h4>
        <button className="btn btn-danger w-100" onClick={handleDeleteAccount}>
          Hesabı Kalıcı Olarak Sil
        </button>
      </div>
    </div>
  );
};

export default UserProfile;
